export const KEY = '---------';

export default function separatorItem() {
  return {
    name: KEY
  };
}



// WEBPACK FOOTER //
// node_modules/@reactual/handsontable/src/plugins/contextMenu/predefinedItems/separator.js